import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL_ESTANDAR } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
interface StickyCtaProps {
  durationHours: number;
}
export function StickyCta({
  durationHours
}: StickyCtaProps) {
  const [visible, setVisible] = useState(false);
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(durationHours);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-262" data-mp="3klr1x37nieud">
      {visible ? <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold-400/25 bg-forest-950/95 px-4 py-2.5 backdrop-blur md:hidden" data-id="element-263" data-mp="3kkfwkyyk4z15">
          <div className="flex items-center gap-3" data-id="element-264" data-mp="27u7gnt5ehw6">
            <div className="min-w-0" data-id="element-265" data-mp="gvp1q8mt0ubd">
              <p className="flex items-baseline gap-1.5" data-id="element-266" data-mp="gwqq1estzdb1">
                <span className="font-display text-xl leading-none text-gold-400" style={{
              fontWeight: 700
            }} data-id="element-267" data-mp="c4yx4xm7cvhq">
                  $19.990
                </span>
                <span className="text-[0.7rem] text-cream-200/60 line-through" data-id="element-268" data-mp="pusl7dpvvbqe">$49.990</span>
              </p>
              <p className="mt-0.5 truncate text-[0.62rem] uppercase tracking-wider text-cream-200/70 tabular-nums" data-id="element-269" data-mp="luihk7pkcxep">
                Termina en {hours}:{minutes}:{seconds}
              </p>
            </div>
            <a href={CHECKOUT_URL_ESTANDAR} className="ml-auto inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-gold-400 px-4 py-3 text-[0.78rem] font-bold uppercase tracking-wide text-forest-950 transition-colors duration-150 ease-out active:bg-gold-300" data-id="element-270" data-mp="utdmzhksa3gy">
              QUIERO APRENDER
              <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-271" data-mp="10lj9gjsi9695" />
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}